namespace khi.bk117.view.parts.scroll
{
	import EventDispatcher = com.enirva.event.EventDispatcher;
	import Sprite = com.enirva.display.Sprite;
	import Tween = com.enirva.tween.Tween;

	/*
	 * スクロールオブジェクト基本くらす　
	 */
	export class ScrollObjectBase extends EventDispatcher
	{
		protected spt:Sprite;

		public isShow:boolean;
		
		protected offsetY:number;

		protected showThresholdY:number;


		constructor(target:JQuery)
		{
			super();

			this.showThresholdY = 100;

			this.spt = new Sprite(target);
			this.offsetY = target.offset().top;
		}


		public update(curr:number, winH:number, isForce:boolean = false):void
		{

		}


		public updateOffset():void
		{
			this.offsetY = this.spt.element.offset().top;
		}
	}
}

